import { render, staticRenderFns } from "./ArticlePhotos.vue?vue&type=template&id=1eee0438&scoped=true"
import script from "./ArticlePhotos.vue?vue&type=script&lang=js"
export * from "./ArticlePhotos.vue?vue&type=script&lang=js"
import style0 from "./ArticlePhotos.vue?vue&type=style&index=0&id=1eee0438&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eee0438",
  null
  
)

export default component.exports